<template>
  <GenericStep v-bind="$attrs">
    <ChildrenCard
      v-for="child of peParty.children"
      :key="child.id"
      class="mb-4"
      :form-only="true"
      :item="child"
    />

    <SectionAdderLine
      section="Child"
      :has-new-section="peChildrenCardHasNewSection"
      @on-add="peChildrenCardAddSection"
    />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import ChildrenCard from '@/components/Party/PartyEdit/SectionCards/FamiliesCards/ChildrenCard.vue'
import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'
import SectionAdderLine from '@/components/Party/PartyEdit/SectionTools/SectionAdderLine.vue'

export default {
  name: 'ChildrenStep',

  components: {
    ChildrenCard,
    GenericStep,
    SectionAdderLine,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return this.peParty.children
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peChildrenCardHasNewSection',
      'peParty',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },

  methods: {
    ...mapActions(PARTY_NAMESPACE, [
      'peChildrenCardAddSection',
    ]),
  },
}
</script>
